const channels = [
  {
    label: 'Email',
    value: 'luiz@luizcavalieri.dev →',
    href: 'mailto:luiz@luizcavalieri.dev',
    external: false,
  },
  {
    label: 'GitHub',
    value: '@luizcavalieri ↗',
    href: 'https://github.com/luizcavalieri',
    external: true,
  },
  {
    label: 'LinkedIn',
    value: '/in/luizcavalieri ↗',
    href: 'https://linkedin.com/in/luizcavalieri',
    external: true,
  },
  {
    label: 'Writing',
    value: 'blog ↗',
    href: 'https://blog.luizcavalieri.dev',
    external: true,
  },
]

export default function ContactPage() {
  return (
    <div className="px-6 md:px-12 py-16 md:py-24 max-w-[1600px] mx-auto">
      <div className="flex flex-col lg:flex-row lg:gap-16 lg:items-start">
        <div className="lg:flex-1 text-left">
          <p className="font-mono uppercase text-[11px] tracking-widest bg-hazard text-ink px-3 py-1 inline-block mb-8">
            Correspondence · Channels
          </p>

          <h1 className="font-display font-extrabold uppercase text-[clamp(64px,10vw,160px)] leading-none tracking-wide text-ink mb-6">
            Drop a{' '}
            <span className="bg-ink text-hazard px-2">line.</span>
          </h1>

          <p className="font-serif italic text-[20px] text-ink-dim mb-16 lg:mb-0">
            Email is best. Reply within a day or two, depending on whether I'm in range.
          </p>
        </div>

        <div className="lg:w-[45%] border-2 border-ink divide-y divide-ink overflow-hidden my-auto">
          {channels.map((ch) => (
            <a
              key={ch.label}
              href={ch.href}
              {...(ch.external
                ? { target: '_blank', rel: 'noopener noreferrer' }
                : {})}
              className="flex justify-between items-center px-6 py-5 bg-paper-2 hover:bg-hazard transition-colors duration-150 group"
            >
              <span className="font-sans font-black uppercase text-sm tracking-wider text-ink">
                {ch.label}
              </span>
              <span className="font-mono text-sm text-ink">
                {ch.value}
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}
